import React from 'react';
import { SectionWrapper } from './Shared';
import { Shield } from 'lucide-react';
export const Guarantee = () => {
  return <SectionWrapper data-id="element-46">
      <div className="max-w-4xl mx-auto bg-gradient-to-b from-prime-card to-prime-black border border-prime-gold/30 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-47">
        {/* Background texture */}
        <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] pointer-events-none" data-id="element-48" />

        <div className="relative z-10" data-id="element-49">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-prime-gold/10 border-2 border-prime-gold mb-8" data-id="element-50">
            <Shield className="w-10 h-10 text-prime-gold" data-id="element-51" />
          </div>

          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-6 uppercase tracking-wider" data-id="element-52">
            La Garantía "Iron-Men"
          </h2>

          <p className="text-xl text-prime-gold font-medium mb-6" data-id="element-53">
            Pruébalo por 60 días sin riesgo.
          </p>

          <p className="text-lg text-prime-textMuted leading-relaxed max-w-2xl mx-auto mb-8" data-id="element-54">
            Si después de aplicar el protocolo de 90 días no te sientes con más
            energía, no ves una reducción en tu cintura o simplemente no estás
            100% satisfecho, envíanos un email y te devolveremos cada centavo.{' '}
            <strong className="text-white" data-id="element-55">Sin preguntas.</strong>
          </p>

          <p className="text-prime-text italic bg-prime-black inline-block px-6 py-3 rounded-lg border border-white/5" data-id="element-56">
            Te quedas con todo el material de todos modos por las molestias. Ese
            es el tamaño de nuestra confianza.
          </p>
        </div>
      </div>
    </SectionWrapper>;
};